import * as cheerio from 'cheerio'

export type ExcerptsOptionsType = {
    append?: string,
    words?: number,
    characters?: number,
}

const prepare = (options: ExcerptsOptionsType) => {
    const rv: ExcerptsOptionsType = { ...options }
    if (!rv.append) rv.append = '...'
    if (!rv.characters && !rv.words) rv.words = 50
    if (rv.words && rv.characters) delete rv.characters
    return rv
}
const excerpts = (html: string, options: ExcerptsOptionsType) => {
    let rv: string = ''
    const opts = prepare(options)
    const $ = cheerio.load(html, null, false)
    const text = $.text()
    if (opts.characters) {
        rv = text.slice(0, opts.characters)
    } else if (opts.words) {
        rv = text.split(' ').slice(0, opts.words).join(' ') + ' '
    }
    rv = rv + opts.append
    return rv
}

export default excerpts